/* @flow */

import { DateTime, Interval } from 'luxon';
import * as types from 'src/shared/app/account/availability/action/availabilityActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {
  isFetching: false,
  result: null,
};

const _fetchRequest = (state: Object) => ({
  ...state,
  isFetching: true,
  result: null,
});

const _fetchFailure = (state: Object) => ({
  ...state,
  isFetching: false,
  result: null,
});

const _setResult = (state: Object, action: Object) => {
  const { result } = action;

  return {
    ...state,
    isFetching: false,
    result,
  };
};

const _addSlot = (state: Object, action: Object) => {
  const { result } = state;
  const { slot } = action;

  if (Array.isArray(result)) {
    return {
      ...state,
      result: [...result, slot],
    };
  }
  return {
    ...state,
    result: [slot],
  };
};

const _deleteSlot = (state: Object, action: Object) => {
  const { result } = state;
  const { slot } = action;

  if (Array.isArray(result) && result.length) {
    const { start_time: slotStart, end_time: slotEnd } = slot;
    const slotStartDateTime = DateTime.fromISO(slotStart);
    const slotEndDateTime = DateTime.fromISO(slotEnd);
    const slotInterval = Interval.fromDateTimes(
      slotStartDateTime,
      slotEndDateTime,
    );

    const index = result.findIndex((item) => {
      const { start_time: itemStart, end_time: itemEnd } = item;
      const itemStartDateTime = DateTime.fromISO(itemStart);
      const itemEndDateTime = DateTime.fromISO(itemEnd);
      const itemInterval = Interval.fromDateTimes(
        itemStartDateTime,
        itemEndDateTime,
      );

      return itemInterval.equals(slotInterval);
    });

    if (index > -1) {
      return {
        ...state,
        result: [...result.slice(0, index), ...result.splice(index + 1)],
      };
    }
  }

  return state;
};

const _deleteResult = (state: Object) => ({
  ...state,
  result: [],
});

export default createReducer(initialState, {
  [types.FETCH_MANUAL_AVAILABILITIES_REQUEST]: _fetchRequest,
  [types.FETCH_MANUAL_AVAILABILITIES_FAILURE]: _fetchFailure,
  [types.FETCH_MANUAL_AVAILABILITIES_SUCCESS]: _setResult,
  [types.SIMULATE_MANUAL_AVAILABILITIES_FETCH]: _fetchRequest,
  [types.ADD_MANUAL_AVAILABILITY_FAILURE]: _setResult,
  [types.ADD_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST]: _addSlot,
  [types.DELETE_MANUAL_AVAILABILITY_SUCCESS]: _setResult,
  [types.DELETE_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST]: _deleteSlot,
  [types.DELETE_ALL_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST]: _deleteResult,
});
